<!-- <form [formGroup]="formGroup" (ngSubmit)="submit()" autocomplete="off" class="entry-form"> -->
<div class="filter-form">
  <form [formGroup]="formGroup" formName="billPaymentFilter" autocomplete="off" class="entry-form">
    <box class="field-set">
      <!-- <ng-container *ngIf="value==paynow;"> -->
      <app-date-control
        class="col-xs-4"
        label="From Date"
        placeholder="From Date"
        formControlName="fromDate"
        [minDate]="state.minDate"
        [maxDate]="state.maxDate"
      ></app-date-control>
      <app-date-control
        class="col-xs-4"
        label="To Date"
        placeholder="To Date"
        formControlName="toDate"
        [minDate]="state.minDate"
        [maxDate]="state.maxDate"
      ></app-date-control>
    </box>
  </form>
</div>

<div class="filter-form-btn">
  <box class="filter-form-btn-grp">
    <button
      *ngIf="formGroup"
      type="button"
      (click)="submitForm()"
      class="button-common button40 active"
      [disabled]="!formGroup.valid || state.isDateValid"
    >
      <span>{{ mode == "MODIFY" ? "Update" : "Submit" }}</span>
    </button>
  </box>
</div>

<div style="display: none">button added</div>
